<template>
  <main class="article-page">
    <JournalFilters back-button />
    <HeroSection :article="article" />
    <ContentSection :article="article" />
    <SubscribeSection />
  </main>
</template>

<script>
import HeroSection from './HeroSection/HeroSection.vue';
import ContentSection from './ContentSection/ContentSection.vue';
import SubscribeSection from '~/components/Common/SubscribeSection/SubscribeSection.vue';
import JournalFilters from '~/components/JournalPage/JournalFilters/JournalFilters.vue';

export default {
  components: {
    JournalFilters,
    HeroSection,
    ContentSection,
    SubscribeSection,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ArticlePage.scss';
</style>
